export default __webpack_public_path__ + "static/media/Landing_bg2024black.f95e51e1.jpg";